<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="奖励积分" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>奖励积分</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" class="text-body-1">
							学生姓名: <span class="text-h6 info--text">{{studentName}}</span>
						</v-col>
						
						<v-col cols="12" class="mt-1">
							<v-text-field v-model="givePoint.pointFee" label="奖励积分" type="number" dense clearable
								outlined></v-text-field>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitGivePoint" :disabled="givePoint.submitting" :loading="givePoint.submitting" color="success">
						确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	export default {
		name:"give-student-point",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			detailId:{
				type:String,
				default:""
			},
			studentName:{
				type:String,
				default:""
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.givePoint.pointFee = "";
					
				}
			}
		},
		data(){
			return {
				
				hideShow:this.show,
				givePoint:{
					submitting:false,
					pointFee:"",
					

				},
			}
		},
		mounted() {
			console.log("give-point mounted");
		},
		methods:{

			cancel(){
				this.$emit("cancel","");
			},
			
			submitGivePoint() {
			
		
			
				if (!this.detailId) {
					this.$noty.error('ID不能为空');
					return
				}
				
				if (!this.givePoint.pointFee) {
					this.$noty.error('积分不能为空');
					return
				}
				
				this.givePoint.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/detail/point/give`;
				let postData = {
					detailId:this.detailId,
					pointFee:this.givePoint.pointFee
				};
			
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("奖励成功");
						
							that.givePoint.submitting = false;
							that.$emit("success","");
							
							return;
						} else {
							that.givePoint.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.givePoint.submitting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			},
		}
	}
	
</script>

<style>
</style>
